<template>
  <div class="canned-accessorials-table">
    <b-col class="canned-select-container">
      <label class="canned-select-container__label" for="accessorials-table"
        >Accessorials</label
      >
    </b-col>
    <div class="open-modal-button-container">
      <a
        v-b-modal.drayage-accessorials-table-modal
        @click="openTable('accessorials')"
        >Show table</a
      >
    </div>
    <b-modal
      no-close-on-backdrop
      hide-header-close
      hide-footer
      static
      id="drayage-accessorials-table-modal"
      size="lg"
      title="Accessorials"
      ref="drayage-accessorials-table-modal"
      @hidden="catchHtmlTable"
    >
      <Searcher
        id="drayage-accessorials-table"
        :fields="accessorialsFields"
        :data="accessorialsTableContent"
        addRows
        deleteRows
        :tableStyles="tableStyles"
        ref="horizontal-table"
      >
        <template #table-header>
          <tr name="table-fields">
            <th :style="tableStyles.header" :colspan="6">Accessorials</th>
          </tr>
        </template>

        <template #key="slotProps">
          <input
            v-for="(row, index) in slotProps"
            :key="index"
            v-model="row.key"
            class="table-canned__table-field"
            type="text"
            cell-type="editable-cell"
          />
        </template>

        <template #value="slotProps">
          <input
            v-for="(row, index) in slotProps"
            :key="index"
            v-model="row.value"
            class="table-canned__table-field"
            type="text"
            cell-type="editable-cell"
          />
        </template>

        <template #note="slotProps">
          <b-form-textarea
            v-for="(row, index) in slotProps"
            :key="index"
            rows="10"
            cols="30"
            v-model="row.note"
            class="table-canned__table-field-notes"
            type="text"
            cell-type="editable-cell"
          ></b-form-textarea>
        </template>
      </Searcher>
      <div class="custom-modal-footer">
        <b-button
          class="custom-modal-footer__ok-button"
          @click="catchHtmlTable"
        >
          OK
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Searcher from "roachcat-components-library/table";
export default {
  name: "Accessorials",
  props: ["currentCannedResponse"],
  components: {
    Searcher
  },
  data() {
    return {
      accessorialsTableContent: null,
      accessorialsFields: [
        {
          label: "Accessorials",
          propName: "key"
        },
        {
          label: "Charge",
          propName: "value"
        },
        {
          label: "Notes",
          propName: "note"
        }
      ],
      tableStyles: {
        table: {
          //Modifica los estilos de la etiqueta “table”
          "border-collapse": "collapse"
        },
        header: {
          //Modifica los estilos de las celdas del header que contiene los campos pasados en la propiedad “fields”.
          "background-color": "rgb(230, 230, 250)",
          border: "1px solid rgb(230, 230, 250)",
          "font-size": "15px",
          padding: "4px 8px"
        },
        th: {
          //Modificar los estilos de cada una de las celdas de la información
          "background-color": "rgb(239, 239, 239)",
          "line-height": "10px",
          border: "1px solid rgb(230, 230, 250)",
          "font-size": "13px"
        }
      },
      actualQueue: null,
      htmlTable: null
    };
  },
  created() {
    this.actualQueue = localStorage.getItem("actual-queue");
    this.getInfoTable();
  },
  mounted() {
    this.setHtmlTable();
  },
  methods: {
    getInfoTable() {
      if (this.currentCannedResponse) {
        this.cannedTableInfo = this.currentCannedResponse?.table_content;
        this.accessorialsTableContent = this.cannedTableInfo;
      }
    },
    openTable() {
      this.$refs["drayage-accessorials-table-modal"].show();
    },
    catchHtmlTable() {
      this.$refs["drayage-accessorials-table-modal"].hide();
      this.setHtmlTable();
    },
    setHtmlTable() {
      this.htmlTable = this.$refs["horizontal-table"].getTableHtml();
      this.htmlTable = this.htmlTable.outerHTML;
      let tableInfo = {};
      tableInfo.tableType = "accessorials";
      tableInfo.tableId = "accessorialsTable1";
      tableInfo.htmlTable = this.htmlTable;
      this.$emit("cannedResponseTable", tableInfo);
    }
  }
};
</script>

<style lang="scss" scoped>
.canned-accessorials-table {
  @extend %canned-tables;
}
::v-deep .table-component {
  padding: 0 1rem;
}
::v-deep .button-toolbar {
  margin: 0;
  display: flex;
  justify-content: start;
  &__button {
    @include secondary-button;
  }
}
::v-deep .table td {
  font-size: 13px;
  padding: 0;
  border: 1px solid rgb(230, 230, 250);
}
::v-deep .table__delete-button {
  & button {
    border-radius: 0.25rem;
  }
}
.table-canned {
  &__table-field {
    display: inline-block;
    border: none;
    min-width: 85px;
    width: 100%;
    height: 28px;
    &:focus {
      outline: none;
    }
  }
  &__table-field-notes {
    display: inline-block;
    border: none;
    height: 45px;
    width: 235px;
    &:focus {
      outline: none;
    }
  }
}
</style>
